<template>
  <div :class="{ 'has-logo': showLogo }" class="slideLeftbg">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path" :num="num" />
        <!-- <el-menu-item style="padding: 0;overflow:hidden" index="kefu">
          <a target="_blank" href="https://csmng.cloud.alipay.com/index.htm#/portal?_k=3hw0dp" style="margin-left: 16px;">
            <i class="el-icon-headset" style="margin-right: 10px;" />
            <span slot="title">客服咨询</span>
          </a>
        </el-menu-item> -->
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { getMessageInfos } from '@/api/user'
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      routeList: this.$router.options.routes,
      routes: this.$router.options.routes,
      identity: this.$store.state.user.userReceptionInfo.identity,
      num: 0
    }
  },
  computed: {
    ...mapGetters(['permission_routes', 'sidebar']),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  watch: {
    '$store.state.user.userReceptionInfo.identity'(newVal, oldVal) {
      this.changeRoute(newVal)
    }
  },
  created() {
    this.getNum()
    this.changeRoute(this.identity)
  },
  methods: {
    async getNum() {
      const res = await getMessageInfos()
      if (res.code === '1000') {
        this.num = res.data.all || 0
      }
    },
    changeRoute(newVal) {
      const arr = ['/user'] // 选手
      this.routeList = this.$router.options.routes
      if (newVal !== 2) {
        this.routes = this.routeList.filter((item) => !arr.includes(item.path))
      } else {
        this.routes = this.$router.options.routes
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.slideLeftbg {
  background: #ffffff !important;
  // background: url("//shopmanage-prod.oss-cn-shenzhen.aliyuncs.com/manage/homebgv2.png") no-repeat;
}
</style>
